import styled from 'styled-components'
import data from '../ChoroplethMap/Assets/municipalities_2023.json'
import { formatPercent } from 'Utils'
import { useContext, useEffect, useRef, useState } from 'react'
import { useWindowSize } from 'usehooks-ts'
import { Search } from 'components/Search'
import GlobalContext from 'Contexts/GlobalContext'

const gde_lookup: { [key: number]: any } = {}
data.forEach((gde: any) => {
  gde_lookup[gde.GDENR] = gde
})



export const NameTable = ({
  nameData,
  currentLocale,
  sorttype = 'rel',
}: {
  nameData: MunicipalityDataElement[]
  currentLocale: any
  sorttype?: 'rel' | 'abs'
}) => {
  const [showAll, setShowAll] = useState(false)
  const [searched, setSearched] = useState<string>()
  const { width } = useWindowSize()
  const isMobile = width < 712
  const colWidth= isMobile ? {
    name: 'auto',
    canton: '60px',
    absolute: '70px',
    relative: '60px',
  } : {
    name: 'unset',
    canton: '60px',
    absolute: '80px',
    relative: '60px',
  }
  const tableRef = useRef<HTMLTableElement>(null)
  const [prepedData, setPrepedData] = useState<any[]>()
  const [sort, setSort] = useState<'name' | 'canton' | 'absolute' | 'relative'>(
    'relative'
  )
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc')
  const headRef = useRef<HTMLTableElement>(null)

  useEffect(() => {
    if (!sorttype) return
    setSort(sorttype === 'rel' ? 'relative' : 'absolute')
  }, [sorttype])

  useEffect(() => {
    let preped = nameData.map((gde: any, i) => {
      let meta = getGdeMeta(gde.bfsId)
      return {
        bfsId: gde.bfsId,
        absolute: gde.abs,
        relative: gde.rel,
        name: meta.GDENAMK,
        canton: meta.GDEKT,
      }
    })
    setPrepedData(preped)
  }, [nameData])

  let sorts = {
    absolute: (a: any, b: any) => {
      return sortDir === 'asc'
        ? a.absolute - b.absolute
        : b.absolute - a.absolute
    },
    relative: (a: any, b: any) => {
      return sortDir === 'asc'
        ? a.relative - b.relative
        : b.relative - a.relative
    },
    name: (a: any, b: any) => {
      return sortDir === 'asc'
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name)
    },
    canton: (a: any, b: any) => {
      return sortDir === 'asc'
        ? a.canton.localeCompare(b.canton)
        : b.canton.localeCompare(a.canton)
    },
  }

  function handleOnSelect(item: any) {
    setSearched(item.id)
    let el = tableRef.current?.getElementsByClassName(
      '_' + item.name.replace(' ', '_')
    )[0]

    if (el) {
      console.log('smooth scroll', el)
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }
  const c = useContext(GlobalContext) as GlobalContext

  return (
    <NameTableRoot>
      <Title>{c.locale.tableTitle}</Title>
      {/* <MapHint>{c.locale.tableHint}</MapHint> */}
      {prepedData && prepedData.length > 10 && (
        <SearchWrapper>
          <Search
            data={
              prepedData?.map((gde, i) => {
                return {
                  id: gde.bfsId,
                  name: gde.name,
                }
              }) || []
            }
            handleOnSelect={handleOnSelect}
            handleOnFocus={() => setShowAll(true)}
            labels={{
              noResults: currentLocale.tablesearch.noResults,
              placeholder: currentLocale.tablesearch.placeholder,
            }}
            small
          />
        </SearchWrapper>
      )}
      <Table id='nametable' ref={headRef}>
        <Head>
          <Row>
            <HeadCell
              style={{
                width: colWidth.name,
                fontWeight: sort === 'name' ? 'bold' : '',
              }}
              onClick={() => {
                if (sort !== 'name') {
                  setSort('name')
                  setSortDir('asc')
                } else {
                  setSortDir(sortDir === 'asc' ? 'desc' : 'asc')
                }
              }}
              className={
                sort === 'name'
                  ? sortDir === 'asc'
                    ? ' sort asc'
                    : ' sort desc'
                  : ''
              }
            >
              {c.locale.nameTableCols[0]}
            </HeadCell>
            {width > 711 && (
              <HeadCell
                style={{
                  width: colWidth.canton,
                  fontWeight: sort === 'canton' ? 'bold' : '',
                  textAlign: 'right',
                }}
                onClick={() => {
                  if (sort !== 'canton') {
                    setSort('canton')
                    setSortDir('asc')
                  } else {
                    setSortDir(sortDir === 'asc' ? 'desc' : 'asc')
                  }
                }}
                className={
                  sort === 'canton'
                    ? sortDir === 'asc'
                      ? ' sort asc'
                      : ' sort desc'
                    : ''
                }
              >
                {c.locale.nameTableCols[1]}
              </HeadCell>
            )}
            <NumberHeadCell
              style={{
                width: colWidth.absolute,
                fontWeight: sort === 'absolute' ? 'bold' : '',
              }}
              onClick={() => {
                if (sort !== 'absolute') {
                  setSort('absolute')
                  setSortDir('desc')
                } else {
                  setSortDir(sortDir === 'asc' ? 'desc' : 'asc')
                }
              }}
              className={
                sort === 'absolute'
                  ? sortDir === 'asc'
                    ? ' sort asc'
                    : ' sort desc'
                  : ''
              }
            >
              {c.locale.nameTableCols[2]}
            </NumberHeadCell>
            <NumberHeadCell
              style={{
                width: colWidth.relative,
                paddingRight: showAll ? '20px' : '0px',
                fontWeight: sort === 'relative' ? 'bold' : '',
              }}
              onClick={() => {
                if (sort !== 'relative') {
                  setSort('relative')
                  setSortDir('desc')
                } else {
                  setSortDir(sortDir === 'asc' ? 'desc' : 'asc')
                }
              }}
              className={
                sort === 'relative'
                  ? sortDir === 'asc'
                    ? ' sort asc'
                    : ' sort desc'
                  : ''
              }
            >
              {c.locale.nameTableCols[3]}
            </NumberHeadCell>
          </Row>
        </Head>
      </Table>
      <FixedContainer>
        <TableWrapper
          className={showAll ? 'isopen ' : ' hideScrollBar'}
          ref={tableRef}
        >
          <Table id='nametable'>
            <Head>
              <Row>
                <HeadCell style={{ border: 0, width: colWidth.name }}></HeadCell>
                {width > 711 && (
                  <HeadCell style={{ width: colWidth.canton, border: 0 }}></HeadCell>
                )}
                <NumberHeadCell
                  style={{ width: colWidth.absolute, border: 0 }}
                ></NumberHeadCell>
                <NumberHeadCell
                  style={{ width: colWidth.canton, border: 0 }}
                ></NumberHeadCell>
              </Row>
            </Head>

            <Body>
              <>
                {prepedData &&
                  prepedData
                    .sort(sorts[sort])
                    .slice(0, showAll ? undefined : 10)
                    .map((gde: any, i) => {
                      const issearched =
                        searched === gde.bfsId ? ' searched' : ' '
                      return (
                        <Row
                          key={'nametable_row_' + i}
                          className={'_' + gde.name.replace(' ', '_')}
                        >
                          <Cell
                            className={issearched}
                            style={{
                              width: colWidth.name,
                              fontWeight: sort === 'name' ? 'bold' : '',
                            }}
                          >
                            {gde.name}
                          </Cell>
                          {width > 711 && (
                            <NumberCell
                              className={issearched}
                              style={{
                                fontWeight: sort === 'canton' ? 'bold' : '',
                              }}
                            >
                              {gde.canton}
                            </NumberCell>
                          )}
                          <NumberCell
                            className={issearched}
                            style={{
                              fontWeight: sort === 'absolute' ? 'bold' : '',
                            }}
                          >
                            {gde.absolute}
                          </NumberCell>
                          <NumberCell
                            style={{
                              
                              width: colWidth.relative,
                              paddingRight: showAll ? '5px' : '0px',
                              fontWeight: sort === 'relative' ? 'bold' : '',
                            }}
                            className={issearched}
                          >
                            {formatPercent(gde.relative)}
                          </NumberCell>
                        </Row>
                      )
                    })}
              </>
            </Body>
          </Table>
        </TableWrapper>
        <Fixed className={showAll ? 'fixed' : ''}>
          <TableWrapper className={showAll ? 'hideScrollBar' : 'hideScrollBar'}>
            <Table id='nametable'>
              <Body>
                {prepedData && prepedData.length > 10 && (
                  <Row>
                    <Cell
                      colSpan={4}
                      style={{ textAlign: 'center', border: 0 }}
                    >
                      <ShowMore
                        onClick={() => {
                          if (headRef.current && isMobile) {
                            headRef.current.scrollIntoView({
                              behavior: 'smooth',
                              block: 'start',
                            })
                          }
                          setShowAll(!showAll)
                        }}
                      >
                        {showAll ? c.locale.showLess : c.locale.showAll}
                      </ShowMore>
                    </Cell>
                  </Row>
                )}
              </Body>
            </Table>
          </TableWrapper>
        </Fixed>
      </FixedContainer>
    </NameTableRoot>
  )
}
const MapHint = styled.div`
  text-align: center;
  max-width: 450px;
  font-size: 12px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4em;
  margin-bottom: 30px;
  color: var(--gray-3);
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 30px);
  }
`

const FixedContainer = styled.div`
  position: relative;
  height: 100%;
`
const Fixed = styled.div`
  &.fixed {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: var(--map-background-color);
  }
`
const ShowMore = styled.div`
  padding: 1rem;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  background-color: var(--text-color);
  color: var(--site-background);
  cursor: pointer;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  @media screen and (min-width: 712px) {
    &:hover {
      background-color: var(--purple-main);
    }
  }
`
function getGdeMeta(bfsId: number) {
  let val = gde_lookup[bfsId]
  if (!val) {
    val = {
      GDENAMK: bfsId + ' NOTFOUND',
      GDENR: bfsId,
      KTKZ: 'NOTFOUND',
      NORMGEMEINDE: 'NOTFOUND',
      NORMORTSNAME: 'NOTFOUND',
      ORTNAME: bfsId + '',
      PLZ4: 0,
      PLZ6: 0,
    }
  }
  return val
}

const Title = styled.h4`
  text-align: center;
  margin-bottom: 10px;
`

const SearchWrapper = styled.div`
  /* max-width: 350px; */
  position: relative;
`
const TableWrapper = styled.div`
  max-height: 500px;
  overflow-y: scroll;
  &.hideScrollBar {
    &::-webkit-scrollbar {
      display: none;
    }
  }
  &.isopen {
    position: relative;
    &::after {
      content: '';
      display: inline-block;
      position: sticky;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 70px;
      border-bottom: 1px solid var(--table-gradient-border-color);
      background: var(--table-gradient);
    }
  }
`
const NameTableRoot = styled.div`
  .results-wrapper {
    margin: 1rem 1rem 1rem 0;
    padding: 0.5rem;
  }
  position: relative;

  .result-span {
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: block;
    padding: 0.5rem 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const Table = styled.table`
  font-size: 18px;
  width: calc(100% - 0px);
  table-layout: fixed;

  border-collapse: collapse;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`
const Head = styled.thead`
  font-size: 15px;
  color: var(--gray-3);
`
const Body = styled.tbody``
const Row = styled.tr``
const Cell = styled.td`
  border-bottom: 1px solid var(--table-cell-border-color);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;

  padding: 2px;
  &.searched {
    background-color: var(--table-search-row-background);
  }
`

const NumberCell = styled(Cell)`
  text-align: right;
  font-size: 14px;
`

const HeadCell = styled(Cell)`
  border-bottom: 1px solid var(--gray-3);
  &.sort {
    position: relative;
    &::after {
      display: inline-block;
      content: '';
      position: absolute;
      top: 15px;
      left: -20px;
      width: 0;
      height: 0;
    }
    &.desc {
      &::after {
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 0;

        border-top: 7px solid var(--gray-1);
      }
    }
    &.asc {
      &::after {
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;

        border-bottom: 7px solid var(--gray-1);
        border-top: 0;
      }
    }
  }
`

const NumberHeadCell = styled(Cell)`
  border-bottom: 1px solid var(--gray-3);

  &:last-of-type {
    padding-right: 10px;
  }
  text-align: right;
  &.sort {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 15px;
      left: -20px;
      width: 0;
      height: 0;
      color: unset;
    }
    &.desc {
      &::after {
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 0;

        border-top: 7px solid var(--gray-1);
      }
    }
    &.asc {
      &::after {
        border-left: 7px solid transparent !important;
        border-right: 7px solid transparent;

        border-bottom: 7px solid var(--gray-1);
        border-top: 0;
      }
    }
  }
`
